import { render, staticRenderFns } from "./VehicleListSettings.vue?vue&type=template&id=196f7f12"
import script from "./VehicleListSettings.vue?vue&type=script&lang=js"
export * from "./VehicleListSettings.vue?vue&type=script&lang=js"
import style0 from "./VehicleListSettings.vue?vue&type=style&index=0&id=196f7f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports